// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * LN1 legacy leading-zeroes configuration.
 */
export class LeadingZeroes implements flatbuffers.IUnpackableObject<LeadingZeroesT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): LeadingZeroes {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsLeadingZeroes(bb: flatbuffers.ByteBuffer, obj?: LeadingZeroes): LeadingZeroes {
    return (obj || new LeadingZeroes()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsLeadingZeroes(
    bb: flatbuffers.ByteBuffer,
    obj?: LeadingZeroes,
  ): LeadingZeroes {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new LeadingZeroes()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string | null;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  name(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  fromDeviceSerial(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  setOneBit(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  reinitializeAllDevices(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  setOneByte(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  rvu(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  rvuHeartbeat(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  refreshAll(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startLeadingZeroes(builder: flatbuffers.Builder) {
    builder.startObject(12);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, nameOffset, 0);
  }

  static addFromDeviceSerial(builder: flatbuffers.Builder, fromDeviceSerial: boolean) {
    builder.addFieldInt8(2, +fromDeviceSerial, +false);
  }

  static addSetOneBit(builder: flatbuffers.Builder, setOneBit: boolean) {
    builder.addFieldInt8(3, +setOneBit, +false);
  }

  static addReinitializeAllDevices(builder: flatbuffers.Builder, reinitializeAllDevices: boolean) {
    builder.addFieldInt8(4, +reinitializeAllDevices, +false);
  }

  static addSetOneByte(builder: flatbuffers.Builder, setOneByte: boolean) {
    builder.addFieldInt8(5, +setOneByte, +false);
  }

  static addRvu(builder: flatbuffers.Builder, rvu: boolean) {
    builder.addFieldInt8(6, +rvu, +false);
  }

  static addRvuHeartbeat(builder: flatbuffers.Builder, rvuHeartbeat: boolean) {
    builder.addFieldInt8(7, +rvuHeartbeat, +false);
  }

  static addRefreshAll(builder: flatbuffers.Builder, refreshAll: boolean) {
    builder.addFieldInt8(8, +refreshAll, +false);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, deletedAtOffset, 0);
  }

  static endLeadingZeroes(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    return offset;
  }

  static createLeadingZeroes(
    builder: flatbuffers.Builder,
    idOffset: flatbuffers.Offset,
    nameOffset: flatbuffers.Offset,
    fromDeviceSerial: boolean,
    setOneBit: boolean,
    reinitializeAllDevices: boolean,
    setOneByte: boolean,
    rvu: boolean,
    rvuHeartbeat: boolean,
    refreshAll: boolean,
    createdAtOffset: flatbuffers.Offset,
    updatedAtOffset: flatbuffers.Offset,
    deletedAtOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    LeadingZeroes.startLeadingZeroes(builder);
    LeadingZeroes.addId(builder, idOffset);
    LeadingZeroes.addName(builder, nameOffset);
    LeadingZeroes.addFromDeviceSerial(builder, fromDeviceSerial);
    LeadingZeroes.addSetOneBit(builder, setOneBit);
    LeadingZeroes.addReinitializeAllDevices(builder, reinitializeAllDevices);
    LeadingZeroes.addSetOneByte(builder, setOneByte);
    LeadingZeroes.addRvu(builder, rvu);
    LeadingZeroes.addRvuHeartbeat(builder, rvuHeartbeat);
    LeadingZeroes.addRefreshAll(builder, refreshAll);
    LeadingZeroes.addCreatedAt(builder, createdAtOffset);
    LeadingZeroes.addUpdatedAt(builder, updatedAtOffset);
    LeadingZeroes.addDeletedAt(builder, deletedAtOffset);
    return LeadingZeroes.endLeadingZeroes(builder);
  }

  unpack(): LeadingZeroesT {
    return new LeadingZeroesT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.name(),
      this.fromDeviceSerial(),
      this.setOneBit(),
      this.reinitializeAllDevices(),
      this.setOneByte(),
      this.rvu(),
      this.rvuHeartbeat(),
      this.refreshAll(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
    );
  }

  unpackTo(_o: LeadingZeroesT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.name = this.name();
    _o.fromDeviceSerial = this.fromDeviceSerial();
    _o.setOneBit = this.setOneBit();
    _o.reinitializeAllDevices = this.reinitializeAllDevices();
    _o.setOneByte = this.setOneByte();
    _o.rvu = this.rvu();
    _o.rvuHeartbeat = this.rvuHeartbeat();
    _o.refreshAll = this.refreshAll();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
  }

  unpackFields(...fields: string[]): LeadingZeroesT {
    const t = new LeadingZeroesT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("from_device_serial")) {
      t.fromDeviceSerial = this.fromDeviceSerial();
    }
    if (fieldSet.has("set_one_bit")) {
      t.setOneBit = this.setOneBit();
    }
    if (fieldSet.has("reinitialize_all_devices")) {
      t.reinitializeAllDevices = this.reinitializeAllDevices();
    }
    if (fieldSet.has("set_one_byte")) {
      t.setOneByte = this.setOneByte();
    }
    if (fieldSet.has("rvu")) {
      t.rvu = this.rvu();
    }
    if (fieldSet.has("rvu_heartbeat")) {
      t.rvuHeartbeat = this.rvuHeartbeat();
    }
    if (fieldSet.has("refresh_all")) {
      t.refreshAll = this.refreshAll();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    return t;
  }
}

export class LeadingZeroesT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public fromDeviceSerial: boolean = false,
    public setOneBit: boolean = false,
    public reinitializeAllDevices: boolean = false,
    public setOneByte: boolean = false,
    public rvu: boolean = false,
    public rvuHeartbeat: boolean = false,
    public refreshAll: boolean = false,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;

    return LeadingZeroes.createLeadingZeroes(
      builder,
      id,
      name,
      this.fromDeviceSerial,
      this.setOneBit,
      this.reinitializeAllDevices,
      this.setOneByte,
      this.rvu,
      this.rvuHeartbeat,
      this.refreshAll,
      createdAt,
      updatedAt,
      deletedAt,
    );
  }

  clone(): LeadingZeroesT {
    const obj = new LeadingZeroesT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.name = this.name;
    obj.fromDeviceSerial = this.fromDeviceSerial;
    obj.setOneBit = this.setOneBit;
    obj.reinitializeAllDevices = this.reinitializeAllDevices;
    obj.setOneByte = this.setOneByte;
    obj.rvu = this.rvu;
    obj.rvuHeartbeat = this.rvuHeartbeat;
    obj.refreshAll = this.refreshAll;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    return obj;
  }

  equals(other: LeadingZeroesT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.name !== other.name) return false;
    if (this.fromDeviceSerial !== other.fromDeviceSerial) return false;
    if (this.setOneBit !== other.setOneBit) return false;
    if (this.reinitializeAllDevices !== other.reinitializeAllDevices) return false;
    if (this.setOneByte !== other.setOneByte) return false;
    if (this.rvu !== other.rvu) return false;
    if (this.rvuHeartbeat !== other.rvuHeartbeat) return false;
    if (this.refreshAll !== other.refreshAll) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    return true;
  }
}

export function verifyLeadingZeroes(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 8, 1);
    verifier.checkScalarField(tablePos, 10, 1);
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 1);
    verifier.checkScalarField(tablePos, 16, 1);
    verifier.checkScalarField(tablePos, 18, 1);
    verifier.checkScalarField(tablePos, 20, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 26);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
